var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{staticStyle:{"width":"984px","height":"262px"},attrs:{"id":"line-chart-dashboard"}})])
}]

export { render, staticRenderFns }